import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createPlasticStockItem,
  getAllPlasticStocksItems,
  getDataForEdit,
  getBillListForVendor,
  getDataForAfterBill,
  adjustPlasticStockItem,
} from "../../store/PlasticStock/PlasticStockSliceApi";

import {
  getAllVendorItems,
  getPlasticListItems,
} from "../../store/AppLevelApi/AppLevelApi";
import { plasticStockSliceAction } from "../../store/PlasticStock/PlasticStockSlice";
import { headTitle } from "../../utility/GetTableListName";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsPlasticStocks } from "../../ConstantData/FormOptions";
//import constant form option to create duplicate field
import { AddMoreFormOptionsPlasticStocks } from "../../ConstantData/AddMoreFormOptions";
//importing inital form data to store value state
import { InitialPlasticStockFormData } from "../../ConstantData/InitialData";
//imporint form data error

//for only adjusted form
import { ErrorPlasticStockFormData } from "../../ConstantData/ErrorOption";
import { adjustedFormPlasticStock } from "../../ConstantData/AdjustedFormOption";
import { InitialAdjustData } from "../../ConstantData/AdjustInitialData";

function PlasticStock() {
  const [showOtherFormBtn, setShowOtherFormBtn] = useState(false); //for only adjust

  const [adjustInitialData, setAdjustInitialData] = useState(InitialAdjustData);

  let newFormOptionsPlasticStock = JSON.parse(
    JSON.stringify(AddMoreFormOptionsPlasticStocks)
  );

  let newFormOptionsPlasticStockText = JSON.parse(
    JSON.stringify(FormOptionsPlasticStocks)
  );
  let newAdjustedFormPlasticStock = JSON.parse(
    JSON.stringify(adjustedFormPlasticStock)
  );
  // let billDataList = useSelector((state) => state.cartoonstock.billDataList);

  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("name"));
    // dispatch(getAllPlasticStocksItems());
    // dispatch(getAllVendorItems());
    // dispatch(getPlasticListItems());
  }, []);

  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const plasticStockList = useSelector(
    (state) => state.plasticstock.plasticStockList
  );

  //for normal form input data initilization
  const InitialFormDataStore = useSelector(
    (state) => state.plasticstock.initialData
  );
  //for normal duplicate form input data initilization
  let InitialFormDuplicateDataStore = useSelector(
    (state) => state.plasticstock.initialDuplicateData
  );

  const plasticStockEditData = useSelector(
    (state) => state.plasticstock.dataEdit
  );
  let plasticStockFormError = useSelector(
    (state) => state.plasticstock.errorData
  );

  let isError = useSelector((state) => state.plasticstock.isError);
  plasticStockFormError = {
    ...ErrorPlasticStockFormData,
    ...plasticStockFormError,
  };
  const vendorList = useSelector((state) => state.applevel.vendorList);
  const plasticList = useSelector((state) => state.applevel.plasticList);
  const billList = useSelector((state) => state.plasticstock.billList);

  function addOptionForSelectFieldDuplicate(
    FormOption,
    list,
    optionName,
    type
  ) {
    if (type === "duplicate") {
      newFormOptionsPlasticStock = FormOption.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    } else {
      newAdjustedFormPlasticStock = adjustedFormPlasticStock.map((item) => {
        if (item?.labelName === optionName) {
          item.options = list;
        }

        return item;
      });
    }
  }
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsPlasticStockText = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }

  if (vendorList.length > 0) {
    // to chage subquality option coming from server4
    addOptionForSelectField(
      newFormOptionsPlasticStockText,
      vendorList,
      "Vendor"
    );
  }

  if (plasticList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      newFormOptionsPlasticStock,
      plasticList,
      "Plastic Type",
      "duplicate"
    );
  }

  if (billList.length > 0) {
    // to chage product option coming from server
    addOptionForSelectFieldDuplicate(
      adjustedFormPlasticStock,
      billList,
      "Bill Number",
      "adjusted"
    );
  } else {
    addOptionForSelectFieldDuplicate(
      adjustedFormPlasticStock,
      [],
      "Bill Number",
      "adjusted"
    );
  }

  const setDataForAdjust = (type) => {
    if (vendorList.length > 0) {
      addOptionForSelectFieldDuplicate(
        adjustedFormPlasticStock,
        vendorList,
        "Vendor",
        "adjusted"
      );
    }
  };

  const inputAdjustHandler = (name, value) => {
    //only for adjust not need for all

    const formData = JSON.parse(JSON.stringify(adjustInitialData)); //deep copy
    if (name === "bill_number") {
      setShowOtherFormBtn((prevState) => !prevState);
      // dispatch(getDataForAfterBill(value.value));
    }
    // if (name === "vendor") dispatch(getBillListForVendor(value.value));
    formData[name] = value;
    setAdjustInitialData(formData);
  };

  const headTitleLabel = headTitle(FormOptionsPlasticStocks, [
    "Cartoon Type",
    "Quantity",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialPlasticStockFormData}
      getDataForEdit={getDataForEdit}
      // delteFun={deletePlasticStockItem}
      createFun={createPlasticStockItem} //create function coming from store
      FormOptions={newFormOptionsPlasticStockText}
      NewFormOptions={newFormOptionsPlasticStock}
      OptionName="Create Plastic Stock"
      OptionNameList="Plastic Stock"
      generalList={plasticStockList}
      headTitle={headTitleLabel}
      EditData={plasticStockEditData}
      isError={isError}
      ErrorData={plasticStockFormError}
      InitialFormDataStore={InitialFormDataStore}
      InitialFormDuplicateDataStore={InitialFormDuplicateDataStore}
      setErrorData={plasticStockSliceAction.setErrorData}
      generalModuleList={vendorList} //list to add different module
      isNotDeleteBtn={true}
      extraAddBtn={true}
      extraButtonText={"Add Cartoon"}
      FormStyle={"!w-[60%] !h-[40rem] custom-scroll-for-nav overflow-y-scroll "}
      secondCreateBtn={false} // to create second button to add extra form
      isSuccess={isSuccess}
      needAdjust={true} //it is used if there is no edit but need adjust
      adjustedFormStock={adjustedFormPlasticStock} //it is used if there is no edit but need adjust
      setDataForAdjust={setDataForAdjust}
      inputAdjustHandler={inputAdjustHandler} //it is used if there is no edit but need adjust
      InitialAdjustData={adjustInitialData} //it is used if there is no edit but need adjust
      listForLength={{ billList }}
      showOtherFormBtn={showOtherFormBtn} // //it is used if there is no edit but need adjust
      createAdjust={adjustPlasticStockItem}
      notShowEditBtn={true} //use when you dont need edit btn
    />
  );
}

export default PlasticStock;
